<template>
  <div class="si-about-area ptb-100">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div
          class="col-lg-5 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="si-about-content">
            <span class="top-title">رؤيتنا في البث المستقر</span>
            <h2>نؤمن بتقديم جودة بث فائقة تمنحك تجربة مشاهدة لا مثيل لها</h2>
            <p>
              تصبح متابعة المباريات والترفيه المنزلي أسهل وأكثر متعة مع سيرفراتنا المدعومة بشبكات قوية تضمن أسرع استجابة لتشغيل القنوات.
            </p>
            <ul class="ps-0 list-unstyled features-list">
              <li>
                <i class="ti ti-circle-check"></i>
                <span>تشغيل الاشتراك على عدة أجهزة في نفس الوقت</span>
              </li>
              <li>
                <i class="ti ti-circle-check"></i>
                <span>جودة تفعيل فورية وسريعة متاحة في كل مكان</span>
              </li>
              <li>
                <i class="ti ti-circle-check"></i>
                <span>ثبات تام للمشاهدة بدون تقطيع طوال اليوم</span>
              </li>
            </ul>
            <div class="starting">
              <span class="startings">الأسعار تبدأ من</span>
              <h1>$9.99<sub>/ شهرياً</sub></h1>
            </div>
            <a href="https://wa.me/447429916178" target="_blank" class="btn">
              <span class="border-style">تصفح خطط الاشتراك</span>
            </a>
          </div>
        </div>

        <div
          class="col-lg-7 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="si-about-images">
            <div class="row justify-content-center">
              <div class="col-lg-6 col-sm-6 col-6">
                <div class="image1">
                  <img
                    src="@/assets/images/satellite-internet/about1.jpg"
                    alt="image"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-6">
                <div class="image2">
                  <img
                    src="@/assets/images/satellite-internet/about2.jpg"
                    alt="image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="si-about-shape">
      <img
        src="@/assets/images/satellite-internet/about-shape.png"
        alt="image"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurSustainableApproach",
});
</script>